// extracted by mini-css-extract-plugin
export default {"modalFooterButtons":"ShippingFormFormEditionModal_modalFooterButtons__Bh-Xx"};